import River from './River.vue';

export default River;
